export enum EStatusReserva {
    Pendente = 1,
    Confirmada = 2,
    Concluida = 3,
    Cancelada = 4,
}
